// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b3461ed1","513":"6bf11913","703":"2ecdfb7e","787":"69458372"}[chunkId] + ".chunk.js";
};